module.exports = __webpack_public_path__ + "static/media/workflowBuilder.6d12a4b9.svg";